import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
  selector: 'tt-business-cos',
  templateUrl: './business-cos.component.html',
  styleUrls: ['./business-cos.component.css']
})
export class BusinessCosComponent implements OnInit {
    public setting?: Setting;

    public itemsListBusinesses: Item[] = [];

    public grid?: GridOptions;

    constructor(private stateService: StateService, private datatask: DataTaskService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(3249))[0];
    }

    private async loadBusinesses() {
        this.itemsListBusinesses = await this.datatask.Post(233);
    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w.businesscos.businessco_grid')
                .setLoadDataFunction({
                    method: 3255,
                    parameters: {}
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true })
                .setCustomToolbarButtons([{
                    name: 'businesscos_new',
                    text: 'businesscos_new',
                    tooltip: 'businesscos_new',
                    translateTooltip: true,
                    func: () => this.stateService?.go('businesscoonboarding'),
                    icon: 'fas fa-plus',
                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                    translate: true,
                    disabled: () => {
                        if (this.setting!.show_businesscos_new === '1') {
                            return false;
                        } else {
                            return 'hidden';
                        }
                    }
                }]);
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private async init() {
        this.loadSetting();
        this.loadBusinesses();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    show_businesscos_new: string;
    show_setting: string;
}
